import css from './index.module.scss';
import { Typography } from '@components/base';
import { useFormContext } from 'react-hook-form';
import QuotePackageWrapper from '../quote-package-wrapper';
import QuotePricePackageWrapper from '../quote-price-package-wrapper';
import UnifiedField from '@components/common/unified-input-field';

const QuoteBaseExWorksPrice = (props: any) => {
  const {
    primaryUnitWatch,
    basePrice,
    basePriceCurrency,
    finalExWorksPrice,
    finalExWorksPriceCurrency,
    selectedCurrency,
    fobPriceManualOverride,
    cfrPriceManualOverride,
    cifPriceManualOverride,
    exWorksPriceManualOverride,
    basePriceWeightUnit,
    finalExWorksPriceWeightUnit,
    selectedWeightSystemChildOptions,
    basePriceWeightUnitWatch,
    finalExWorksPriceWeightUnitWatch,
    ddpPriceManualOverride
  } = props;

  const { setValue, control } = useFormContext();

  return (
    <div className={css.rowWrapper}>
      <QuotePricePackageWrapper
        label="Base Price"
        control={control}
        input={basePrice}
        inputPlaceholder="Enter Price"
        inputOnChange={() => {
          setValue(exWorksPriceManualOverride, false, { shouldDirty: false });
          setValue(fobPriceManualOverride, false, { shouldDirty: false });
          setValue(cfrPriceManualOverride, false, { shouldDirty: false });
          setValue(cifPriceManualOverride, false, { shouldDirty: false });
          setValue(ddpPriceManualOverride, false, { shouldDirty: false });
        }}
        unit={basePriceWeightUnit}
        unitPlaceholder="Per Unit"
        unitOptions={selectedWeightSystemChildOptions}
        currency={basePriceCurrency}
        currencyOptions={selectedCurrency}
        currencyPlaceholder="Currency"
      />
      <QuotePricePackageWrapper
        label="Ex-Works Price"
        control={control}
        input={finalExWorksPrice}
        inputPlaceholder="Enter Price"
        inputOnChange={() => {
          setValue(ddpPriceManualOverride, false, { shouldDirty: false });
          setValue(fobPriceManualOverride, false, { shouldDirty: false });
          setValue(cfrPriceManualOverride, false, { shouldDirty: false });
          setValue(cifPriceManualOverride, false, { shouldDirty: false });
          setValue(basePrice, 0);
        }}
        unit={finalExWorksPriceWeightUnit}
        unitPlaceholder="Per Unit"
        unitOptions={selectedWeightSystemChildOptions}
        unitOnChange={() => {
          setValue(exWorksPriceManualOverride, false, { shouldDirty: false });
        }}
        currency={finalExWorksPriceCurrency}
        currencyOptions={selectedCurrency}
        currencyPlaceholder="Currency"
      />
    </div>
  );
};

export default QuoteBaseExWorksPrice;
